import { useContext } from "react"
import { AppContext } from "../App"
import { STR_CONTACT_US } from "../Strings";
import { MdCall, MdEmail } from 'react-icons/md';
import MobileInterface from "../MobileInterface";
import { FaWhatsapp } from "react-icons/fa";

export default function ContactUs(props) {

  const appContext = useContext(AppContext);

  const contactOptions = [
    {
      label: "WhatsApp",
      icon: <FaWhatsapp className="align-self-center" size={40} style={{ flexShrink: "0" }} />,
      url: "https://wa.me/255749487578",
    },
    {
      label: "+255 749 487 578",
      icon: <MdCall className="align-self-center" size={40} style={{ flexShrink: "0" }} />,
      url: "tel:+255749487578",
    },
    {
      label: "support@werenium.com",
      icon: <MdEmail className="align-self-center" size={40} style={{ flexShrink: "0" }} />,
      url: "mailto:support@werenium.com",
    },
  ];

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        overflow: "scroll",
        paddingTop: "20px",
      }}
      className="mNoScrollBar"
    >
      <div className="container">
        <div className="row" style={{ marginTop: "10px", marginBottom: "30px" }}>
          <div className="col-md-12">
            <h6 className="main-section-title">
              {STR_CONTACT_US[appContext.language]}
            </h6>
          </div>

          {contactOptions.map((option) => (
            <div className="col-12 mt-2 mb-2" key={option.url}>
              <div
                className="d-flex bg-surface mShadow3"
                style={{
                  padding: "10px",
                  fontSize: "12px",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={() => MobileInterface.openLink(option.url)}
              >
                {option.icon}
                <h6
                  className="align-self-center font-semi-bold mNoMargin"
                  style={{ fontSize: "14px", paddingLeft: "10px" }}
                >
                  {option.label}
                </h6>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
